import { CSSProperties, useRef, useState } from 'react';

import LinkedInLogo from './linkedin-logo.svg';
import GitHubLogo from './github-logo.svg';
import MastodonLogo from './mastodon-logo.svg';
import './App.scss';

const Apps = [
  {
    img: 'vendas-icon.png',
    appId: 'br.com.uol.ps'
  },
  {
    img: 'smart-pos.webp',
    url: 'https://pagseguro.uol.com.br/para-seu-negocio/maquininhas/moderninha-smart-2'
  },
  {
    img: 'pagbank-icon.png',
    appId: 'br.com.uol.ps.myaccount'
  },
  {
    img: 'clip-icon.png',
    appId: 'com.payclip.clip'
  },
  {
    img: 'dosh-icon.png',
    appId: 'com.dosh.client'
  },
  {
    img: 'mercadopago-icon.png',
    url: 'https://www.mercadopago.com.br'
  }
]

const PlayStoreUrl = `https://play.google.com/store/apps/details?id=`

function App() {
  let screenHeight = window.screen.availHeight

  let [isDockedClassName, setIsDockedClassName] = useState('')
  const mainRef = useRef<HTMLDivElement>(null);

  // FASE 4: Estados de Controle
  const [animationState, setAnimationState] = useState({
    currentState: 'static',
    previousState: 'static',
    stateChangedAt: 0
  });

  // FASE 1: Sistema de Medições e Constantes
  const calculateDimensions = () => {
    const viewport = {
      width: window.innerWidth,
      height: window.innerHeight
    }

    const dimensions = {
      viewport,
      initialScale: 2.0,     // 200% - tamanho inicial
      finalScale: 1.0,       // 100% - tamanho final (docked)
      collisionPoint: viewport.height * 0.6,  // onde começar transição
      dockingHeight: viewport.height * 0.25   // altura final do header docked
    }

    return dimensions
  }

  // FASE 2: Sistema de Detecção de Colisão
  const detectCollisionState = (scrollTop: number, dimensions: any) => {
    const states = {
      STATIC: 'static',        // Conteúdo fixo, background se movendo
      TRANSITIONING: 'transitioning', // Conteúdo começando a reagir
      DOCKING: 'docking',      // Chegando na posição final
      DOCKED: 'docked'         // Posição final fixa
    }

    // Pontos de transição mais precisos
    const startTransition = dimensions.collisionPoint * 0.5  // 70% da collision point
    const endTransition = dimensions.collisionPoint * 1.3   // 130% da collision point

    let currentState = states.STATIC
    let transitionProgress = 0  // 0 a 1 - progresso da transição

    if (scrollTop <= startTransition) {
      currentState = states.STATIC
      transitionProgress = 0
    } else if (scrollTop > startTransition && scrollTop <= endTransition) {
      currentState = states.TRANSITIONING
      transitionProgress = (scrollTop - startTransition) / (endTransition - startTransition)
    } else if (scrollTop > endTransition) {
      currentState = states.DOCKED
      transitionProgress = 1
    }

    const collision = {
      state: currentState,
      progress: transitionProgress,
      startTransition,
      endTransition,
      isInTransition: currentState === states.TRANSITIONING
    }

    // Log para validação - apenas mudanças de estado
    if (scrollTop < 100 || scrollTop % 100 === 0) {
      console.log('🎯 Collision State:', collision)
    }

    return collision
  }

  // FASE 3: Engine de Animação SIMPLES
  const calculateProgressiveTransforms = (collision: any, dimensions: any) => {

    // Cálculos básicos de transformação
    const transforms = {
      scale: dimensions.initialScale,
      translateY: 0,
      opacity: 1
    }

    if (collision.state === 'static') {
      // Estado inicial: sem mudanças
      transforms.scale = dimensions.initialScale
      transforms.translateY = 0
    }
    else if (collision.isInTransition) {
      // ABORDAGEM SUPER SIMPLES: apenas escala progressiva
      const scaleDiff = dimensions.initialScale - dimensions.finalScale
      transforms.scale = dimensions.initialScale - (scaleDiff * collision.progress)

      // Movimento MÍNIMO: apenas 1/10 do scroll para evitar saltos
      const scrollMovement = -(collision.progress * 100) // Max 100px para toda a transição
      transforms.translateY = scrollMovement

      // Log mínimo
      if (collision.progress > 0.1 && collision.progress < 0.9) {
        console.log(`📍 Simple - Progress: ${collision.progress.toFixed(2)}, Scale: ${transforms.scale.toFixed(2)}, Move: ${transforms.translateY.toFixed(0)}px`)
      }
    }
    else if (collision.state === 'docked') {
      // Estado final: valores fixos simples
      transforms.scale = dimensions.finalScale
      transforms.translateY = -100 // Movimento final fixo
    }

    return transforms
  }




  return (
    <div className="App">
      <div className={`Header ${isDockedClassName}`}>
        <div id='main' ref={mainRef}>
          <img src="logo.svg" className="App-logo" alt="logo" />
          <div className='Side'>
            Developing solutions and people
          </div>
          <div className='Contact'>
            <a href="https://www.linkedin.com/in/rodrigoamarorodrigues/" target="_new"><img src={LinkedInLogo} /></a>
            <a href="https://github.com/RodrigoAmaroEng" target="_new"><img src={GitHubLogo} /></a>
            <a href="https://mastodon.social/@rodrigoamaro@mastodon.social" target="_new"><img src={MastodonLogo} /></a>
            <a href="https://stackoverflow.com/users/2615142/amaro" target="_new"></a>
          </div>
        </div>
        <div className='ScrollIndicator'>
          <div className='ScrollArrow'>↓</div>
          <div className='ScrollText'>Scroll</div>
        </div>
      </div>
      <div id='face' className={isDockedClassName}></div>
      <div className='Main'>
        <div className='Section'>
          <article>
            <h1 style={{ textAlign: 'center' }}>Hey, I'm Rodrigo Amaro, a Brazilian systems architect passionate about delivering tech solutions that make everyone's lives better</h1>
          </article>
        </div>
        <div className='Section'>
          <article>
            <h2>Portfolio</h2>
            <div className='Portfolio'>
              {Apps.map((it: any) => (
                <a target="_new" href={it.url ?? PlayStoreUrl + it.appId}><img src={it.img} /></a>
              ))}
            </div>
          </article>
        </div>
        <div className='Section'>
          <article>
            <h2>Personal projects</h2>
            <div className='Project'>
              <a href="https://amaro-dev.github.io/android-compare/" target="new"><h5>Screenwise</h5></a>
              <div>A tool to compare different Android screen sizes and visualize how the content will differ in each one</div>
            </div>
            <div className='Project'>
              <a href="https://github.com/amaro-dev/sonic" target="new"><h5>Sonic</h5></a>
              <div>A small wrapper to implement MVI multiplatform projects using Kotlin</div>
            </div>
            <div className='Project'>
              <a href="https://github.com/amaro-dev/c3po" target="new"><h5>C3po</h5></a>
              <div>A macOS desktop application for Android developers to explore, debug, and manage Android devices via ADB with an intuitive interface</div>
            </div>
          </article>
        </div>
        <div className='Section'>
          <article style={{ width: '100%' }}>
            <h2>Experience</h2>
            <div className='Timeline'>
              <div className='Company' aria-label='Apr/24'>
                <h5>Mercado Pago 🇧🇷</h5>
                <label>Technical Lead</label>
                <div className='About'>
                  Mercado Pago is one of Latin America's leading fintech companies, part of Mercado Libre group, providing comprehensive payment solutions across Brazil, Argentina, Colombia, Chile, and Mexico.
                </div>
                <div className='Accomplishments'>
                  <ul>
                    <li>Technical leadership in structuring two teams focused on evolving the Smart POS device payment platform</li>
                    <li>Defined architecture and base framework for segmenting monolithic application into 20+ micro apps</li>
                    <li>Developed a Launcher that transformed user experience and increased solution scalability</li>
                    <li>Led and mentored 10+ professionals with direct involvement in mentoring, performance recovery, and technical guidance</li>
                    <li>Designed distributed architecture for migrating mobile monolith to modular mini apps ecosystem</li>
                    <li>Coordinated efforts across 20+ micro apps ensuring technical alignment and delivery consistency</li>
                    <li>Enhanced development processes by creating custom plugin, pipeline integration with DevOps team, and defining application monitoring metrics</li>
                    <li>Adopted AI strategies following company policy to accelerate both code development and process evolution</li>
                  </ul>
                </div>
                <ul className='TechStack'>
                  <li>Android</li>
                  <li>Kotlin</li>
                  <li>SmartPOS</li>
                  <li>C/C++</li>
                  <li>AOSP</li>
                  <li>AI</li>
                </ul>
              </div>
              <div className='Company' aria-label='Jan/22'>
                <h5>Cardlytics 🇺🇸</h5>
                <label>Team lead / Mobile developer</label>
                <div className='About'>
                  Through partnerships with top banks, Cardlytics have a complete view of consumer spend, including purchases they make at competitors. This purchase intelligence is the foundation of all their offered services.
                </div>
                <div className='Accomplishments'>
                  <ul>
                    <li>Maintainament and enhancement of their Android library</li>
                    <li>Coordination and support for the App team</li>
                    <li>Process and solutions proposals to improve the development cycle</li>
                    <li>Managed/Mentored other developers in the company</li>
                  </ul>
                </div>
                <ul className='TechStack'>
                  <li>Android</li>
                  <li>Java</li>
                  <li>Kotlin</li>
                  <li>GraphQL</li>
                  <li>Node.JS</li>
                  <li>React.JS</li>
                </ul>
              </div>
              <div className='Company' aria-label='Apr/20'>
                <h5>Clip 🇲🇽</h5>
                <label>Engineer Manager</label>
                <div className='About'>
                  Providing both mobile and in-site payment solution, Clip is one of the biggest fintechs in Mexico.
                </div>

                <div className='Accomplishments'>
                  <ul>
                    <li>Security assessment for all payment devices of the company</li>
                    <li>Revision of the development cycle and reorganization of the teams</li>
                    <li>Improvements on the CI/CD process to comply with the PCI requirements</li>
                    <li>Implementation of an APM system for all mobile apps</li>
                    <li>Coordination with many hardware providers</li>
                    <li>Complete revamp of their SDK</li>
                  </ul>
                </div>
                <ul className='TechStack'>
                  <li>Android</li>
                  <li>Java</li>
                  <li>Kotlin</li>
                  <li>GitHub/Actions</li>
                </ul>
              </div>
              <div className='Company' aria-label='Jan/12'>
                <h5>PagSeguro 🇧🇷</h5>
                <label>Senior/Lead developer - Mobile</label>
                <div className='About'>
                  PagSeguro is a fintech company based in Sao Paulo - Brazil that provides payment solutions for their clients. Back this February it opened capital on the NYSE with a huge impact.
                </div>
                <div className='Accomplishments'>
                  <ul>
                    <li>Deployed the first mobile payment system in Brazil built from the scratch</li>
                    <li>Project and implementation for the integration with multiple card reader devices. Bluetooth / Audio Jack port</li>
                    <li>Responsible for the design and implementation of the CI/CD process</li>
                    <li>Creation of 2 SDKs for providing mobile payment services to other applications</li>
                    <li>Lead developer on of the first Smart PoS devices in Brazil (Android embeeded) </li>
                    <li>Lead developer for the PagBank (Banking App) expansion coordinating the work of more than 30 teams</li>
                  </ul>
                </div>
                <ul className='TechStack'>
                  <li>Android</li>
                  <li>Java</li>
                  <li>Kotlin</li>
                  <li>Jenkins</li>
                  <li>Oracle</li>
                  <li>REST</li>
                  <li>Bitbucket/Stash</li>
                  <li>BitRise</li>
                  <li>BrowserStack</li>
                </ul>
              </div>
              <div className='Company' aria-label='Sep/10'>
                <h5>Petrobras 🇧🇷</h5>
                <label>Senior developer - Fullstack </label>
                <div className='About'>Petrobras is an oil company currently controlled by the Brazilian government with operations all around the globe.</div>
                <div className='Accomplishments'>
                  <ul>
                    <li>Maintainament of several legacy Asp 3.0 systems</li>
                    <li>Project and implementation of a new inventory fuel control system in refineries, written in Asp.Net C# 3.5</li>
                    <li>Implemented an Access Control system to improve security in refineries. C# for Windows CE embeeded portable devices</li>
                    <li>Project for a fuel sample management system using RFID. C# for Windows CE embeeded portable devices</li>
                    <li>Part of a study group for mobile applications</li>
                  </ul>
                </div>
                <ul className='TechStack'>
                  <li>Asp 3.0</li>
                  <li>Asp.Net</li>
                  <li>C#</li>
                  <li>HTML</li>
                  <li>JavaScript</li>
                  <li>C# for Mobile (Windows CE)</li>
                  <li>Android</li>
                  <li>Java</li>
                  <li>Microsoft SQL Server</li>
                  <li>Oracle</li>
                  <li>ClearCase</li>
                </ul>
              </div>
              <div className='Company' aria-label='Mar/06'>
                <h5>Foster 🇧🇷</h5>
                <label>Developer - Fullstack</label>
                <div className='About'>Foster is a marketing agency and software house, part of the WPP group</div>
                <div className='Accomplishments'>
                  <ul>
                    <li>Developed several promotional websites for famous Brazilian brands using Asp 3.0</li>
                    <li>Built new features for the company's white label CMS solution, written in Asp.Net C# 3.5</li>
                    <li>Deployed this CMS with both layout and feature customizations on several clients</li>
                  </ul>
                </div>
                <ul className='TechStack'>
                  <li>Asp 3.0</li>
                  <li>Asp.Net</li>
                  <li>C#</li>
                  <li>Visual Basic (.Net)</li>
                  <li>HTML</li>
                  <li>JavaScript</li>
                  <li>XSLT</li>
                  <li>Microsoft SQL Server</li>
                  <li>VCS/VSS</li>
                  <li>SVN</li>
                </ul>
              </div>
              <div className='TheLine'></div>
            </div>
            <div style={{ marginBottom: '5vh' }}></div>
          </article>
        </div>
        <div className='Section'>
          <article>
            <h2>Background</h2>
            <div className='Timeline'>
              <div className='Background' aria-label='Nov/10'>
                <h5>Postgraduate degree in Systems Analysis</h5>
                <label>Universidade Presbiteriana Mackenzie</label>
              </div>
              <div className='Background' aria-label='Jan/07'>
                <h5>Microsoft Certification</h5>
                <label>Asp.NET web developer</label>
              </div>
              <div className='Background' aria-label='Nov/05'>
                <h5>Bachelor Computer Engineer degree</h5>
                <label>Universidade Santa Cecília</label>
              </div>
              <div className='TheLine'></div>
            </div>
          </article>
        </div>
      </div>
    </div>
  );
}

export default App;
